import './src/styles.css';
import React from 'react';
import Layout from './src/components/Layout';

export const wrapPageElement = ({ element, props }) => (
  <Layout location={props.location}>{element}</Layout>
);
